import { useState } from "react";

const styles = {
    input:{
        borderRadius: "5px ",
        padding: "5px",
        margin: "5px",
        border: "none",
        background: "#f8fafc",
        width: "100%",
    }
}

const useTimePicker = () => {
    const [startDate, setStartDate] = useState("2021-01-01");
    const DateComponent =(
        <input
            type="time"
            id="start"
            name="trip-start"
            value={startDate}
            onChange={
                (e) => setStartDate(e.target.value)
            }
            style={styles.input}
        />
    )
    return {
        get: startDate,
        date: DateComponent,
        set: setStartDate
    }
}
export default  useTimePicker;